{
  "WHATSAPP_TEMPLATE_MGMT": {
    "TITLE": "Vorlagen",
    "DESCRIPTION": "Zeigt die Nachrichtenvorlagen an, die aus Ihren WhatsApp-Posteingängen synchronisiert wurden. Um eine Vorlage zu erstellen oder zu bearbeiten, verwalten Sie sie bei Ihrem Anbieter.",
    "COUNT": "{n} Vorlage | {n} Vorlagen",
    "LEARN_MORE": "Erfahren Sie mehr über WhatsApp-Vorlagen",
    "SYNC_TEMPLATES": "Vorlagen synchronisieren",
    "SYNC_SUCCESS": "Die Synchronisierung der Vorlagen wurde für alle WhatsApp-Posteingänge gestartet. Aktualisierungen können einige Minuten dauern.",
    "PARTIAL_SYNC_ERROR": "Die Synchronisierung der Vorlagen wurde für einige WhatsApp-Posteingänge gestartet, andere konnten jedoch nicht synchronisiert werden.",
    "SYNC_ERROR": "Die Synchronisierung der Vorlagen konnte nicht gestartet werden. Bitte versuchen Sie es erneut.",
    "SEARCH_PLACEHOLDER": "Nach Inhalt oder Namen suchen...",
    "MANAGE_IN_META": "In Meta verwalten",
    "LOADING": "WhatsApp-Vorlagen werden geladen...",
    "EMPTY": "Keine WhatsApp-Vorlagen gefunden.",
    "NO_RESULTS": "Keine Vorlagen entsprechen Ihren Filtern.",
    "FETCH_ERROR": "WhatsApp-Vorlagen konnten nicht geladen werden. Bitte versuchen Sie es erneut.",
    "PARTIAL_FETCH_ERROR": "Einige WhatsApp-Vorlagen konnten nicht geladen werden. Bitte versuchen Sie es erneut.",
    "LAST_SYNC_ATTEMPT": "Letzter Synchronisierungsversuch am {date}",
    "MORE_INBOXES": "+{n}",
    "STATUSES": {
      "UNSUBMITTED": "Nicht zur WhatsApp-Genehmigung eingereicht"
    },
    "FILTERS": {
      "ALL_INBOXES": "Alle Posteingänge",
      "ALL_LANGUAGES": "Alle Sprachen",
      "ALL_TYPES": "Alle Typen"
    },
    "TYPES": {
      "TEXT": "Text",
      "IMAGE": "Bild",
      "VIDEO": "Video",
      "DOCUMENT": "Dokument",
      "CALL_TO_ACTION": "Handlungsaufforderung",
      "COPY_CODE": "Code kopieren"
    },
    "PREVIEW": {
      "TITLE": "Vorlagenvorschau",
      "DESCRIPTION": "Vorschau, wie diese Vorlage in WhatsApp erscheint.",
      "OPEN": "Vorschau von {name}",
      "CLOSE": "Vorschau schließen",
      "DETAILS": "Vorlagendetails",
      "STATUS": "Status",
      "TYPE": "Inhaltstyp",
      "CATEGORY": "Kategorie",
      "LANGUAGE": "Sprache",
      "INBOXES": "Posteingänge"
    }
  }
}
